var map = {
	"./AOMSIN.jpeg": "8a95",
	"./KBANK.jpeg": "2daa",
	"./KSB.jpeg": "c4b2",
	"./KTB.jpeg": "cba7",
	"./SCB.jpeg": "8de9",
	"./TTB.jpeg": "ebb5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d1a2";